import React, { useCallback, useEffect, useState } from "react";
import { Add, DeleteOutline, Pause } from "@material-ui/icons";
import { Button, Card, CardContent, Chip, IconButton, Paper, TextField, Typography } from "@material-ui/core";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const blank = { name: "", audience: "Todos los contactos", message: "", status: "borrador" };

export default function Campaigns() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(blank);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/crm/campaigns/");
      setItems(data.campaigns || []);
    } catch (error) {
      toastError(error);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async event => {
    event.preventDefault();
    try {
      await api.post("/crm/campaigns", form);
      setForm(blank);
      await load();
    } catch (error) {
      toastError(error);
    }
  };

  const pause = async item => {
    try {
      await api.put(`/crm/campaigns/${item.id}`, { ...item, status: "pausada" });
      await load();
    } catch (error) {
      toastError(error);
    }
  };

  const remove = async id => {
    try {
      await api.delete(`/crm/campaigns/${id}`);
      await load();
    } catch (error) {
      toastError(error);
    }
  };

  return (
    <MainContainer>
      <MainHeader><Title>{"Campa\u00f1as"}</Title><Chip label="Solo borradores" /></MainHeader>
      <div style={{ padding: 16, overflowY: "auto", minWidth: 0 }}>
        <Typography color="textSecondary" paragraph>
          {"Dise\u00f1\u00e1 campa\u00f1as, audiencias y mensajes. No se har\u00e1 ning\u00fan env\u00edo hasta habilitarlo expresamente."}
        </Typography>
        <Paper component="form" onSubmit={save} variant="outlined" style={{ padding: 16, marginBottom: 16 }}>
          <Typography variant="subtitle1">{"Nueva campa\u00f1a"}</Typography>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12, marginTop: 12 }}>
            <TextField required fullWidth label="Nombre" value={form.name} onChange={event => setForm({ ...form, name: event.target.value })} />
            <TextField fullWidth label="Audiencia" value={form.audience} onChange={event => setForm({ ...form, audience: event.target.value })} />
            <TextField required fullWidth multiline rowsMin={2} label="Mensaje" value={form.message} onChange={event => setForm({ ...form, message: event.target.value })} />
          </div>
          <Button type="submit" startIcon={<Add />} variant="contained" color="primary" style={{ marginTop: 14 }}>Crear borrador</Button>
        </Paper>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 14 }}>
          {items.map(item => (
            <Card variant="outlined" key={item.id} style={{ minWidth: 0 }}>
              <CardContent>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
                  <Typography variant="h6" style={{ overflowWrap: "anywhere" }}>{item.name}</Typography>
                  <Chip size="small" label={item.status} />
                </div>
                <Typography color="textSecondary" variant="body2" style={{ overflowWrap: "anywhere" }}>{item.audience}</Typography>
                <Typography style={{ marginTop: 12, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{item.message}</Typography>
                <div style={{ marginTop: 14, display: "flex", justifyContent: "flex-end" }}>
                  <IconButton aria-label={"Pausar campa\u00f1a"} onClick={() => pause(item)}><Pause /></IconButton>
                  <IconButton aria-label="Eliminar campa\u00f1a" onClick={() => remove(item.id)}><DeleteOutline /></IconButton>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </MainContainer>
  );
}
